// AuthActions.js
import Medical from "../../jsx/components/Dashboard/Medical";
import {
  login,
  saveTokenInLocalStorage,
  logout,
} from "../../services/AuthService";

export const LOGIN_CONFIRMED_ACTION = "LOGIN_CONFIRMED_ACTION";
export const LOGIN_FAILED_ACTION = "LOGIN_FAILED_ACTION";
export const LOGOUT_ACTION = "LOGOUT_ACTION";
export const NAVTOGGLE = "NAVTOGGLE";
export const RESET_MENU = "RESET_MENU";
export const LOADING_TOGGLE_ACTION = "[Loading action] toggle loading";

export function loginConfirmedAction(userDetails) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: userDetails,
  };
}

export function loginFailedAction(errorMessage) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: errorMessage,
  };
}

// export function logoutAction() {
//   logout();
//   return {
//     type: LOGOUT_ACTION,
//   };
// }
// above code is befor api logoot
// AuthActions.js

export function logoutAction() {
  return async (dispatch) => {
    try {
      await logout(); // now returns a Promise
    } catch (error) {
      console.error("Error during logout:", error);
    } finally {
      dispatch({ type: LOGOUT_ACTION });
    }
  };
}

export const loadingToggleAction = (isLoading) => ({
  // type: "LOADING_TOGGLE",
  type: LOADING_TOGGLE_ACTION,
  payload: isLoading,
});

export const navtoggle = () => {
  return {
    type: NAVTOGGLE,
  };
};

export const resetMenu = () => {
  return {
    type: RESET_MENU,
  };
};

// maybe other actions like loginAction, logoutAction, etc.

export function loginAction(username, password) {
  return (dispatch) => {
    return login(username, password)
      .then((response) => {
        if (response.data.status === "success") {
          const userData = response.data.data;

          // ✅ FIRST check 2FA
          if (userData.enable_2fa === "Yes") {
            return {
              is2FA: true,
              data: userData,
            };
          }

          // ✅ ONLY for non-2FA users
          saveTokenInLocalStorage(userData);

          if (userData.token) {
            localStorage.setItem("token", userData.token);
          }

          dispatch(loginConfirmedAction(userData));

          return {
            is2FA: false,
            data: userData,
          };
        } else {
          dispatch(loginFailedAction(response.data.message || "Login failed"));
          throw new Error(response.data.message);
        }
      })
      .catch((error) => {
        dispatch(loginFailedAction(error.message || "Something went wrong"));
        throw error;
      });
  };
}
// import { login, saveTokenInLocalStorage, logout } from '../../services/AuthService';

// export const LOGIN_CONFIRMED_ACTION = 'LOGIN_CONFIRMED_ACTION';
// export const LOGIN_FAILED_ACTION = 'LOGIN_FAILED_ACTION';
// export const LOGOUT_ACTION = 'LOGOUT_ACTION';

// export function loginConfirmedAction(userDetails) {
//   return {
//     type: LOGIN_CONFIRMED_ACTION,
//     payload: userDetails,
//   };
// }

// export function loginFailedAction(errorMessage) {
//   return {
//     type: LOGIN_FAILED_ACTION,
//     payload: errorMessage,
//   };
// }

// export function logoutAction() {
//   logout();
//   return {
//     type: LOGOUT_ACTION,
//   };
// }

// export const loadingToggleAction = (isLoading) => ({
//   type: "LOADING_TOGGLE",
//   payload: isLoading,
// });

// // Updated loginAction to include role-based redirection
// export function loginAction(username, password, navigate) {
//   return (dispatch) => {
//     login(username, password)
//       .then((response) => {
//         if (response.data.status === 'success') {
//           const userData = response.data.data;

//           // Save the user token (or any relevant data)
//           saveTokenInLocalStorage(userData);

//           // Dispatch login success action
//           dispatch(loginConfirmedAction(userData));

//           // Role-based redirection logic
//           const role = userData?.role_name;
//           const roleRedirectMap = {
//             Doctor: "/doctor",
//             Receptionist: "/receptionist",
//             Telecaller: "/telecaller",
//             Admin: "/dashboard",
//             Counsellor: "/counsellor",
//             ServiceCaller: "/service-caller",
//           };

//           // Redirect based on role
//           navigate(roleRedirectMap[role] || "/dashboard");
//         } else {
//           dispatch(loginFailedAction(response.data.message || 'Login failed'));
//         }
//       })
//       .catch((error) => {
//         dispatch(loginFailedAction(error.message || 'Something went wrong'));
//       });
//   };
// }
